import moment from "moment";

export const formatNumber = (value, fractionDigits) => {
    return parseFloat(value).toLocaleString(undefined, {
      minimumFractionDigits: fractionDigits === undefined ? 2 : fractionDigits,
      maximumFractionDigits: fractionDigits === undefined ? 2 : fractionDigits,
    });
  };

export const formatPoints = (value, fractionDigits) => {
    return formatNumber(value, fractionDigits);
  };
  
// Portal-wide date model: zero-padded DD/MM/YYYY (with HH:mm for date-times).
export const formatDate = (value) => {
    if (!value) return "";
    return moment(value).format("DD/MM/YYYY");
};

export const formatDateTime = (value) => {
    if (!value) return "";
    return moment(value).format("DD/MM/YYYY HH:mm");
};
  
export const formatCurrency = (value, fractionDigits) => {
    return (
      "$" +
      formatNumber(value, fractionDigits)
    );
};
  
export const formatPercentage = (value, fractionDigits) => {
    return (
        formatNumber(value, fractionDigits) + "%"
    );
};